import React, {useEffect, useState} from 'react';
import './DropzoneAvatar.scss';
import {ReactComponent as TrashIcon} from '../../../assets/icons/trash.svg';
import PropTypes from 'prop-types';
import {setModalAdditional} from '../../../redux/actions/app/appActions';
import {useDispatch} from 'react-redux';
import {ReactComponent as AvatarIcon} from '../../../assets/icons/avatarIcon.svg';
import AvatarPopup from '../AvatarPopup';
import {useTranslation} from 'react-i18next';
import {LoaderMUI} from '../../../shared';

const DropzoneAvatar = ({
                            onFileAdded,
                            images,
                            initialAvatar,
                            initialAvatarUrl = {},
                            path,
                            disabled = false,
                            needLoader = true
                        }) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [avatar, setAvatar] = useState({});
    const [avatarLoading, setAvatarLoading] = useState(needLoader);
    const removeAvatar = () => {
        setAvatar({});
        onFileAdded({});
    };

    const handleShowAvatarPopup = () => {
        if (disabled) return;
        dispatch(setModalAdditional(path));
    };

    useEffect(() => {
        if (Object.keys(avatar).length) {
            onFileAdded(avatar?.id);
        }
    }, [avatar]);

    useEffect(() => {
        const setInitialFiles = async () => {
            try {
                if (Object.keys(initialAvatarUrl).length > 0) {
                    setAvatar(initialAvatarUrl);
                    onFileAdded(initialAvatarUrl?.id);
                    handleLoadingDisable();
                } else {
                    handleLoadingDisable();
                }
            } catch (error) {
                console.error('Ошибка при загрузке начальных файлов:', error);
                handleLoadingDisable();
            }
        };
        setInitialFiles();
    }, []);

    const handleLoadingDisable = () => {
        if (!needLoader) return;
        setTimeout(() => {
            setAvatarLoading(false);
        }, 250);
    };

    return (
        <>
            <div className={'dropzone-avatar'}>
                <div className={`dropzone-avatar__wrapper`}>
                    <div
                        className={`dropzone-avatar__input dropzone-avatar__avatar${
                            avatar.length && !disabled > 0 ? 'has-trash' : ''
                        }${disabled ? ' disabled' : ''}`}
                        onClick={handleShowAvatarPopup}
                    >
                        <div className={`dropzone-avatar-content`}>
                            {avatarLoading ? (
                                <>
                                    <div className='dropzone-avatar__icon'>
                                        <LoaderMUI noBg={true} staticPos={true}/>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='dropzone-avatar__icon'>
                                        {Object.keys(avatar).length > 0 ? (
                                            <img
                                                src={avatar?.avatar || ''}
                                                alt='Avatar Preview'
                                            />
                                        ) : (
                                            <>{initialAvatar ? <img src={initialAvatar} alt={'avatar'}/> :
                                                <AvatarIcon/>}</>
                                        )}
                                    </div>
                                    <p className='dropzone-avatar-text'>
                                        {Object.keys(avatar).length > 0 ? t('DropzoneAvatar.changeLogo') : t('DropzoneAvatar.chooseLogo')}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                    {!avatarLoading && Object.keys(avatar).length > 0 && !disabled && (
                        <div className='dropzone-avatar__trash' onClick={() => removeAvatar()}>
                            <TrashIcon/>
                            {t('DropzoneAvatar.delete')}
                        </div>
                    )}
                </div>
                <div className='dropzone-notation'>
                    <p>{t('profileSettings.requiredField2')}</p>
                </div>
            </div>
            <AvatarPopup setAvatar={setAvatar} avatar={avatar} images={images} path={path}/>
        </>
    );
};

DropzoneAvatar.propTypes = {
    onFileAdded: PropTypes.any,
    avatarText: PropTypes.string,
    avatarChangeText: PropTypes.string,
    images: PropTypes.any,
    initialAvatarUrl: PropTypes.any
};

export default DropzoneAvatar;
